import React, { useContext, useEffect, useState } from "react";

import Card from "../../Components/Card";
import SocketContext from "../../Contexts/SocketContext";
import Spinner from "../../Components/Loaders/Spinner";
import HorizontalStackedBarChart from "./AircraftCharts/HorizontalStackedBarChart";
import moment from "moment";
import DateRangePicker from "../../Components/Calendars/DateRangePicker";
import Table from "../../Components/Table/Index";
import useAircraftColumns from "./AircraftColumns";

const AircraftAnalytics = ({}) => {
  const socket = useContext(SocketContext);
  const [loading, setLoading] = useState(true);

  const [selectedDateRange, setSelectedDateRange] = useState({
    start: moment().subtract(30, "days").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
  });
  const { columns } = useAircraftColumns();
  const [data, setData] = useState();
  useEffect(() => {
    if (socket) {
      socket.emit("showAircraftAnalytics", selectedDateRange);
      socket.on("aircraftAnalytics", (data) => {
        setData(data);
        setLoading(false);
      });
    }
  }, [socket, selectedDateRange]);

  return (
    <div className="pb-12">
      <h1 className="text-3xl font-bold mb-4">Aircraft Analytics</h1>
      <div className="flex space-x-4 justify-end">
        <DateRangePicker onDateSelect={setSelectedDateRange} />
      </div>
      <div className="space-y-12 mt-4">
        <Card>
          <p className=" font-semibold text-lg mb-4">
            Aircraft usage by os-system
          </p>
          {loading ? (
            <div className="h-[300px] flex items-center justify-center w-full">
              <Spinner height="h-8 w-8" />
            </div>
          ) : (
            <>
              <Table
                defaultSortBy={[{ id: "total", desc: true }]}
                data={data?.aircraft_usage_per_os_system?.map((item) => {
                  return {
                    acft: item.acft,
                    total: item.total ? parseInt(item.total) : 0,
                    android: item.android ? parseInt(item.android) : 0,
                    ios: item.ios ? parseInt(item.ios) : 0,
                    win64: item.win64 ? parseInt(item.win64) : 0,
                    linux: item.linux ? parseInt(item.linux) : 0,
                    macos: item.macos ? parseInt(item.macos) : 0,
                    switch: item.switch ? parseInt(item.switch) : 0,
                    "android %": item?.android
                      ? ((item.android / item.total) * 100)?.toFixed(0)
                      : 0,
                    "ios %": item?.ios
                      ? ((item.ios / item.total) * 100)?.toFixed(0)
                      : 0,
                    "win64 %": item?.win64
                      ? ((item.win64 / item.total) * 100)?.toFixed(0)
                      : 0,
                    "linux %": item?.linux
                      ? ((item.linux / item.total) * 100)?.toFixed(0)
                      : 0,
                    "macos %": item?.macos
                      ? ((item.macos / item.total) * 100)?.toFixed(0)
                      : 0,
                    "switch %": item?.switch
                      ? ((item.switch / item.total) * 100)?.toFixed(0)
                      : 0,
                  };
                })}
                columns={columns}
              />
              <div className="mt-12">
                <HorizontalStackedBarChart
                  data={data?.aircraft_usage_per_os_system ?? []}
                  showOsSystems
                />
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
};

export default AircraftAnalytics;
